// extracted by mini-css-extract-plugin
module.exports = {"GroupCard__container":"GroupCard__container__3rznh","GroupCard__shadow":"GroupCard__shadow__29ijK"};